// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"145":"2b65462e","319":"b93413b7"}[chunkId] + ".chunk.js";
};